import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        chapterForm: '=',
        trainingIndex: '=',
        materialIndex: '=',
        material: '=',
        chapterIndex: '=',
        isDisabled: '=',
        form: '=',
        error: '=',
        context: '=',
        delete: '&',
        save: '&'
    },
    template: `
        <form>
             <div class="heading heading-toggle" ng-click="vm.chapterForm.isOpened=!vm.chapterForm.isOpened;$event.stopPropagation()">
                <form-row
                    style="width:100%"
                    error="vm.form.errors.courseTrainings[vm.trainingIndex].materials[vm.materialIndex].chapters[vm.chapterIndex]">
                    <div class="row row-wide" style="width:100%">
                        <div class="items hasactions" ng-if="!vm.nameHidden || !vm.chapterForm.name">
                            <input
                                type="text"
                                ng-model="vm.chapterForm.name"
                                class="form-control wide"
                                ng-click="$event.stopPropagation();vm.nameHidden=false;"
                                placeholder="{{ vm.getChapterPlaceholder(vm.chapterIndex) }}"
                                ng-change="vm.material.isEnabled=true"
                            >
                        </div>
                        <h3 ng-if="vm.nameHidden && vm.chapterForm.name" class="ng-scope">
                            <span>{{ vm.chapterForm.name }}<span>
                            <button
                                class="btn ico-edit ng-scope"
                                ng-click="vm.nameHidden=false;$event.stopPropagation()"
                            >
                                <span class="visuallyhidden">Edit</span>
                            </button>
                        </h3>
                    </div>
                </form-row>
            </div>
            <div class="a">
                <form-row-wide error="vm.error.content">
                    <label class="label visuallyhidden">{{ chapter.content }}</label>
                    <div class="items" style="max-width: 100%">
                        <tinymce upload-url="vm.uploadUrl" chapter="vm.chapterForm" ng-model="vm.chapterForm.content"></tinymce>
                        <form-row-wide-error></form-row-error>
                    </div>
                </form-row-wide>
                <div class="block04__inner">
                    <div class="row inline nowrap hasactions">
                        <div class="items inline">
                            <div class="row has-error" ng-if="vm.error.content">{{ vm.error.content }}</div>
                        </div>
                        <ul class="actions01">
                            <li class="primary">
                                <a ng-click="vm.delete()" class="btn delete small">{{ 'course.materialSource.Delete chapter' | translate }}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </form>
    `
})
export default class {
    constructor (TokenService, $rootScope, $translate) {
        this.$rootScope = $rootScope;
        this.TokenService = TokenService;
        this.$translate = $translate;

        if (this.context === 'add') {
            if (!this.chapterForm.isOpened) {
                this.chapterForm.isOpened = true;
            }
        }

        this.nameHidden = this.context === 'edit' && this.chapterForm.name;
    }

    $onInit () {
        this.uploadUrl = `${SEED_CORE.ENV.API_URL}course/material-chapter-file`;
    }

    getChapterPlaceholder (index) {
        const chapterName = this.$translate.instant('course.materialSource.Chapter');
        return `${chapterName} ${index + 1}`;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/authoringTool/chapter/index.js